import React from 'react'
import styled from 'styled-components'

type Props = {
  children?: React.ReactNode
}

export function ErrorMessage({ children }: Props) {
  return <Message>{children}</Message>
}

const Message = styled.span`
  position: absolute;
  font-size: 0.75rem;
  color: var(--color-primary);
  bottom: -1.4rem;
  left: 0;
`
